// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__EjRGQ","image":"Header_image__1y73r","name":"Header_name__252wH","info":"Header_info__3lACW","infoRow":"Header_infoRow__3dGOY"};